const BeginIntakeSection = ({ onStart }) => {
  return (
    <div className="max-w-2xl mx-auto py-12 px-4">
      <div className="text-center space-y-6">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900">
          Welcome to Our Intake Process
        </h1>
        <p className="text-lg text-gray-600 max-w-xl mx-auto">
          We're here to help you get started. This intake form helps us understand your needs better and provide the best possible care.
        </p>
      </div>

      <div className="mt-12 bg-white rounded-sm shadow-sm border border-gray-200 p-6 space-y-6">
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-900">Before You Begin</h2>
          
          <div className="space-y-3">
            <h3 className="text-sm font-medium text-gray-900">What You'll Need:</h3>
            <ul className="list-disc pl-5 text-sm text-gray-600 space-y-2">
              <li>Basic personal and contact information</li>
              <li>Medical history and current health information</li>
              <li>Insurance details (if applicable)</li>
              <li>Emergency contact information</li>
            </ul>
          </div>

          <div className="space-y-3">
            <h3 className="text-sm font-medium text-gray-900">Important Notes:</h3>
            <ul className="list-disc pl-5 text-sm text-gray-600 space-y-2">
              <li>Your progress will be automatically saved after each section</li>
              <li>You can return to this form anytime using the same link</li>
              <li>The form takes approximately 15-20 minutes to complete</li>
              <li>All information provided is kept confidential</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-gray-200">
          <button
            onClick={onStart}
            className="w-full sm:w-auto inline-flex justify-center items-center px-4 py-2.5 border border-transparent text-sm font-medium rounded-sm shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Begin Intake Form
            <svg
              className="ml-2 -mr-1 h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeginIntakeSection;
